export function* generateIncrementingNumbers() {
  let i = 1;
  const maxNumberOfEmployeers = 550;
  while (i <= maxNumberOfEmployeers) {
    yield `${i++}`;
  }
}
